// extracted by mini-css-extract-plugin
module.exports = {"contents":"rd","sectionHeading":"sd"};